<script>
  import { link, navigate } from "svelte-routing";
  import { writable } from 'svelte/store';
  import pb from '../../lib/pocketbase';
  import { onMount, onDestroy } from 'svelte';
  import PowerTechLogo from '../../components/Brand/PowerTechLogo.svelte';
  import { getHomeRouteForRole } from '../../lib/roles.js';

  export let location;

  let email = '';
  let password = '';
  let rememberMe = false;
  const error = writable(null);

  onMount(() => {
    const apiKey = "7728c3c0ec5332a339b1e89666a4d2ed";
    fetch(`https://api.flickr.com/services/rest/?method=flickr.photosets.getPhotos&api_key=${apiKey}&photoset_id=72177720302447704&user_id=130115410%40N08&format=json&nojsoncallback=1`)
      .then(response => response.json())
      .then(data => {
        const index = Math.floor(Math.random() * data.photoset.photo.length);
        const photo = data.photoset.photo[index];
        const bgURL = `url(https://farm${photo.farm}.staticflickr.com/${photo.server}/${photo.id}_${photo.secret}_b.jpg)`;
        document.body.style.backgroundImage = bgURL;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center center';
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.backgroundRepeat = 'no-repeat';
      });
  });

  onDestroy(() => {
    document.body.style.backgroundImage = '';
    document.body.style.backgroundSize = '';
    document.body.style.backgroundPosition = '';
    document.body.style.backgroundAttachment = '';
    document.body.style.backgroundRepeat = '';
  });

  async function handleSubmit(event) {
    event.preventDefault();

    if (!email || !password) {
      error.set("Por favor, completa todos los campos.");
      return;
    }

    try {
      await pb.collection('users').authWithPassword(email, password);
      localStorage.setItem('pb_token', pb.authStore.token);
      localStorage.setItem('pb_user', JSON.stringify(pb.authStore.model));

      if (rememberMe) {
        pb.authStore.save(pb.authStore.token, pb.authStore.model, { expires: 30 * 24 * 60 * 60 });
      } else {
        pb.authStore.save(pb.authStore.token, pb.authStore.model, { expires: 24 * 60 * 60 });
      }

      let role = null;
      if (pb.authStore.model?.role) {
        role = await pb.collection('role').getOne(pb.authStore.model.role);
        localStorage.setItem('pb_user_role', JSON.stringify(role));
      }

      navigate(getHomeRouteForRole(role));
    } catch (err) {
      error.set(err.message || 'Error al iniciar sesión');
    }
  }
</script>

<div class="w-full max-w-md mx-auto relative z-10">
  <div class="relative flex flex-col w-full shadow-lg rounded-lg bg-blueGray-200 bg-opacity-90 border-0 overflow-hidden">
    <div class="bg-white px-4 py-3 flex justify-center border-b border-blueGray-300">
      <PowerTechLogo size="lg" />
    </div>

    <div class="px-6 lg:px-10 py-8">
      <div class="text-blueGray-500 text-center mb-6 font-bold">
        <small>Inicia sesión con tus credenciales</small>
      </div>

      <form on:submit={handleSubmit}>
        <div class="relative w-full mb-3">
          <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-email">
            Correo Electrónico
          </label>
          <input
            id="grid-email"
            type="email"
            bind:value={email}
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            placeholder="Correo Electrónico"
          />
        </div>

        <div class="relative w-full mb-3">
          <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
            Contraseña
          </label>
          <input
            id="grid-password"
            type="password"
            bind:value={password}
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            placeholder="Contraseña"
          />
        </div>

        <label class="inline-flex items-center cursor-pointer">
          <input
            id="customCheckLogin"
            type="checkbox"
            bind:checked={rememberMe}
            class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
          />
          <span class="ml-2 text-sm font-semibold text-blueGray-600">Recuérdame</span>
        </label>

        <div class="text-center mt-6">
          <button
            class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none w-full ease-linear transition-all duration-150"
            type="submit"
          >
            Iniciar Sesión
          </button>
        </div>

        {#if $error}
          <div class="text-red-500 text-sm mt-3 text-center">{$error}</div>
        {/if}
      </form>
    </div>
  </div>

  <div class="auth-links flex justify-between items-center mt-5 px-1 text-sm">
    <a href="#erpsys" on:click={(e) => e.preventDefault()} class="auth-link">
      ¿Olvidaste tu contraseña?
    </a>
    <a use:link href="/auth/register" class="auth-link">
      Crear nueva cuenta
    </a>
  </div>
</div>

<style>
  .auth-link {
    color: #fff;
    font-weight: 600;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.85);
  }

  .auth-link:hover {
    color: #e2e8f0;
  }
</style>
